<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <CareTabsContainer :tabs :tabs-label="i18n(translations.tabsBarLabel)">
        <OpenTasks v-if="isOpenTasksActive" @update-task-count="refresh" />
        <AllRequests v-if="isAllRequestsActive" @update-task-count="refresh" />
      </CareTabsContainer>
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useAsyncData, useRoute } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { GetRequestsQueryParams } from '~/api/seller-after-sales/types/requests.types'
import { ROUTE_NAMES } from '~/constants/routes'

import translations from './CustomerCare.translations'
import AllRequests from './components/AllRequests/AllRequests.vue'
import CareTabsContainer from './components/CareTabsContainer/CareTabsContainer.vue'
import OpenTasks from './components/OpenTasks/OpenTasks.vue'

const i18n = useI18n()
const route = useRoute()
const $httpFetch = useHttpFetch()

const openTasksLink = { name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS }
const isOpenTasksActive = computed(() => route.name === openTasksLink.name)

const allRequestsLink = {
  name: ROUTE_NAMES.CUSTOMER_CARE.ALL_REQUESTS,
}
const isAllRequestsActive = computed(() => route.name === allRequestsLink.name)

const queryParams: GetRequestsQueryParams = {
  sort: 'DEADLINE',
  pageSize: 1,
  status: 'TODO',
}

const { data: metadata, refresh } = useAsyncData(
  () =>
    $httpFetch('/seller-after-sales/api/v1/requests', {
      query: queryParams,
    }),
  {
    lazy: true,
  },
)

const openTasksCount = computed(() => metadata.value?.metadata.totalCount)

const tabs = computed(() => [
  {
    key: 'open-tasks',
    label: i18n(translations.openTasksTabTitle),
    to: openTasksLink,
    isActive: isOpenTasksActive.value,
    dataQa: 'customer-care-open-tasks-tab',
    badgeCount: openTasksCount.value,
  },
  {
    key: 'all-requests',
    label: i18n(translations.allRequestsTabTitle),
    to: allRequestsLink,
    isActive: isAllRequestsActive.value,
    dataQa: 'customer-care-all-requests-tab',
  },
])
</script>
